import store from '@/store'

export default {
  getStorageById(id) {
    const storageList = store.getters['Storage/getStorageListFromState']
    const ret = storageList.find((v) => v.storageId == id)
    return ret
  },
  async getStorageIdNameList(isHideUnusedStorage = false) {
    const storageList = isHideUnusedStorage
      ? await store.dispatch('Storage/getStorageListFromApi', {
          isHideUnusedStorage: 1
        })
      : await store.dispatch('Storage/getStorageListFromApi')
    // API実行失敗
    if (!storageList) {
      return {}
    }
    const storageIdNameList = storageList.data.map((ele) => {
      return { label: ele.name, value: ele.storageId }
    })
    return {
      code: storageList.code,
      message: storageList.message,
      data: storageIdNameList
    }
  }
}
